import React, { useState } from 'react';
import OverlayMenu from './OverlayMenu';

function BurgerMenu() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <button onClick={toggleMenu} className="focus:outline-none">
        {/* Burger Icon */}
        <div className="burger-lines space-y-1.5">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </button>
    </>
  );
}

export default BurgerMenu;
